import { render } from "./appraisal-edit-modal.vue?vue&type=template&id=56631f96"
import script from "./appraisal-edit-modal.vue?vue&type=script&lang=js"
export * from "./appraisal-edit-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__